import
{
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { PopupService } from "@service/popup/popup.service";
import { WindowRefService } from "@service/window-service/window-ref.service";
import { Subject } from "rxjs";
import { showAfterSecond } from "../../../../../utils/utilsFunctions";


@Component({
    selector: "app-confirmation-popup",
    templateUrl: "./confirmation-popup.component.html",
    styleUrls: ["./confirmation-popup.component.scss"],
    standalone: false
})
export class ConfirmationPopupComponent implements OnDestroy, OnInit
{
  public showModal: boolean = false;
  public loaded = [];

  @Input() private name: string = "";
  @Input() public content: string = "";
  @Output()
  public readonly confirm: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public windowRef: WindowRefService,
    private changeDet: ChangeDetectorRef,
    private popupService: PopupService,
  ) { }

  ngOnInit(): void
  {
    this.popupService.reserveName(this.name);
  }

  public openModal(): void
  {
    this.windowRef.blockScroll();
    this.showModal = true;
    this.popupService.openPopup(this.name);
    this.changeDet.detectChanges();
    showAfterSecond(100, this.loaded, this.changeDet);
  }

  public confirmModal()
  {
    this.confirm.emit();
    this.closeModal();
  }

  public closeModal(): void
  {
    this.windowRef.unBlockScroll();
    this.popupService.closePopup(this.name);
    this.showModal = false;
    this.loaded["loaded"] = false;
  }

  public ngOnDestroy(): void
  {
    this.popupService.clearName(this.name);
  }
}
